export default "__VITE_ASSET__DKqbUfEy__"